import { TextTooltip } from '~/@mid_ui/text-tooltip/TextTooltip'
import {
  IN_THE_END_PAYMENT_TYPE_LABEL,
  MONTHLY_PAYMENT_TYPE_LABEL,
  YIELD_COMPOUNDING_PAYMENT_TYPE_LABEL,
} from './getProjectPaymentTypeLabel'

const paymentTypeTooltipTexts: Record<
  string,
  { text: string; linkText?: string; linkUrl?: string }
> = {
  [MONTHLY_PAYMENT_TYPE_LABEL]: {
    text: 'Úroky sa pripisujú do investorskej peňaženky každý mesiac. Investičné príležitosti trvajú zvyčajne 12 - 30 mesiacov.',
  },
  [YIELD_COMPOUNDING_PAYMENT_TYPE_LABEL]: {
    text: 'Úroky sa pripisujú mesačne a v každom ďalšom období sa úročia spolu s istinou. Minimálny úrok pri investícii 50 € na dobu 12 mesiacov; maximálny úrok pri investícii nad 10 000 € na maximálnu dobu splatnosti, zvyčajne 60 mesiacov.',
    linkText: 'Zistiť viac o rastúcom úroku',
    linkUrl: `${import.meta.env.VITE_REACT_LANDING_PAGE_ORIGIN}/blogs/preco-investori-miluju-zlozene-urocenie-a-ako-to-funguje-na-invest-in-slovakia`,
  },
  [IN_THE_END_PAYMENT_TYPE_LABEL]: {
    text: 'Úrok aj istina sa vyplácajú spoločne po skončení investičného obdobia, bez priebežných mesačných výplat. Investičné príležitosti trvajú zvyčajne 12 - 30 mesiacov.',
  },
}

type Props = {
  paymentTypeLabel: string
}

function ProjectPaymentTypeTooltip({ paymentTypeLabel }: Props) {
  const tooltipText = paymentTypeTooltipTexts[paymentTypeLabel] || null

  if (tooltipText === null) return null

  return (
    <TextTooltip
      text={tooltipText.text}
      linkText={tooltipText.linkText}
      linkUrl={tooltipText.linkUrl}
    />
  )
}

export { ProjectPaymentTypeTooltip }
